import { render, staticRenderFns } from "./AddNewWorkBookModal.vue?vue&type=template&id=b453dc28&scoped=true"
import script from "./AddNewWorkBookModal.vue?vue&type=script&lang=js"
export * from "./AddNewWorkBookModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewWorkBookModal.vue?vue&type=style&index=0&id=b453dc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b453dc28",
  null
  
)

export default component.exports